import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import ThemeButtonFloating from 'assets/components/button/themes/Theme.Button.Floating';
import Icon from 'assets/components/icon/Icon';
import { getLocales } from 'assets/locales/Locale';
import { isEmpty } from 'lodash';
import { isMobile } from 'react-device-detect';
import {
  ContractRefundPaymentItemAction,
  useContractRefundPaymentItemProvider,
} from '../Finance.ContractRefundPaymentItem.Hooks';

export default function ContractRefundPaymentItemActions() {
  const { lang } = getLocales();
  const { listApi, pageRouter, selectedItems, permissions, disableCreatePayment, exportToExcel, isExporting } =
    useContractRefundPaymentItemProvider();

  return (
    <>
      <Button
        class={ThemeButtonCircle}
        active
        media={<Icon class="fas-money-check-alt" />}
        render={lang.createPayment}
        onClick={pageRouter.updateParams}
        data={{ action: ContractRefundPaymentItemAction.CREATE_PAYMENT }}
        disabled={!selectedItems || disableCreatePayment}
        htmlElementProps={{
          title: isEmpty(selectedItems)
            ? lang.noItemsAdded
            : disableCreatePayment
              ? lang.unableToProcessRefundPaymentItems
              : undefined,
        }}
      />
      <Button
        class={isMobile ? ThemeButtonFloating : ThemeButtonCircle}
        active
        media={<Icon class="fas-download" />}
        render={!isMobile && lang.export}
        onClick={exportToExcel}
        disabled={!permissions.CREATE_CONTRACTREFUNDPAYMENT || isEmpty(listApi?.payload?.data) || isExporting}
      />
    </>
  );
}
